import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getProductImage } from "../../data/images";
import { COLLECTION_COPY } from "../../data/products";
import { Reveal } from "../Reveal";
import { SectionHeading } from "../SectionHeading";

const STACKS = [
  { id: "everyday", name: "The Everyday Stack", note: "Subtle. Stylish. You." },
  { id: "minimal", name: "The Minimal Stack", note: "Clean. Modern. Timeless." },
  { id: "statement", name: "The Statement Stack", note: "Bold. Beautiful. Unstoppable." },
];

// Build Your Stack — three curated starting points into the catalogue.
export const BuildYourStack = ({ editProducts = {} }) => (
  <section className="border-t border-brand-gold/15 bg-brand-champagne/60 py-20 sm:py-28 lg:py-32" data-testid="build-stack-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionHeading
          align="center"
          overline="Style Your Way"
          title="Build Your Stack"
          text="Begin with one, layer with feeling — three stacks our stylists reach for first."
        />
      </Reveal>
      <div className="mt-12 grid gap-6 sm:mt-16 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
        {STACKS.map((s, i) => {
          const entry = editProducts[s.id];
          const img = entry?.image ? getProductImage(entry.image, entry.name) : null;
          return (
            <Reveal key={s.id} delay={i * 0.1}>
              <Link
                to={`/shop?category=${s.id}`}
                data-testid={`stack-card-${s.id}`}
                aria-label={`Shop ${s.name}`}
                className="group block overflow-hidden border border-brand-sand bg-brand-surface transition-[transform,box-shadow,border-color] duration-500 ease-out hover:-translate-y-1.5 hover:border-brand-gold/60 hover:shadow-[0_28px_50px_-30px_rgba(28,25,23,0.35)]"
              >
                <div className="relative aspect-[4/3] overflow-hidden bg-white">
                  {img?.src ? (
                    <img
                      src={img.src}
                      alt={`${s.name} — HESHAURA ${COLLECTION_COPY[s.id].title.toLowerCase()} bracelets`}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
                    />
                  ) : (
                    <img
                      src="/brand/product-placeholder.svg"
                      alt={`${s.name} — HESHAURA photograph coming soon`}
                      loading="lazy"
                      className="h-full w-full object-cover"
                    />
                  )}
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-brand-charcoal/15 to-transparent" />
                </div>
                <div className="flex items-end justify-between gap-4 px-5 py-5 sm:px-6">
                  <div>
                    <h3 className="font-serif text-xl font-medium text-brand-charcoal transition-colors duration-300 group-hover:text-brand-gold sm:text-2xl">
                      {s.name}
                    </h3>
                    <p className="mt-1 font-serif text-sm italic text-brand-stone">{s.note}</p>
                  </div>
                  <span className="inline-flex shrink-0 items-center gap-1.5 pb-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-brand-gold">
                    Shop the look
                    <ArrowRight className="h-3 w-3 transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
